// removed by extract-text-webpack-plugin
module.exports = {"privacy-policy-container":"privacy-policy-container","privacy-content":"privacy-content","last-updated":"last-updated","contact-info":"contact-info"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/PrivacyPolicy/PrivacyPolicy.scss
// module id = 4568
// module chunks = 1